import { AfterViewInit, Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import * as fromConstants from '../app/constants';
import * as fromServices from './services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  notificationList: Notification[];

  constructor(
    private toolIdentifier: fromServices.ToolIdentifierService,
    private titleService: Title,
    private metaService: Meta
  ) {}

  private initMetaData(): void {
    const toolType = this.toolIdentifier.getCurrentTool();
    switch (toolType) {
      case fromServices.LocatorTools.HIVMedicalProvider:
        this.titleService.setTitle(fromConstants.PageNames.HivProgram);
        this.metaService.updateTag({
          name: 'description',
          content: fromConstants.MetaDescription.FindHIVCare
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: fromConstants.MetaKeyWords.FindHIVCare
        });
        break;
      case fromServices.LocatorTools.HealthCenter:
        this, this.titleService.setTitle(fromConstants.PageNames.FindAHealthCenterProgram);
        this.metaService.updateTag({
          name: 'description',
          content: fromConstants.MetaDescription.FindAHealthCenter
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: fromConstants.MetaKeyWords.FindAHealthCenter
        });
        break;
      case fromServices.LocatorTools.HealthCenterControlledNetwork:
        this.titleService.setTitle(fromConstants.PageNames.FindANetworkProgram);
        this.metaService.updateTag({
          name: 'description',
          content: fromConstants.MetaDescription.FindANetwork
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: fromConstants.MetaKeyWords.FindANetwork
        });
        break;
      case fromServices.LocatorTools.MigrantSeasonalHeadStart:
        this.titleService.setTitle(fromConstants.PageNames.MigrantHeadStartProgram);
        this.metaService.updateTag({
          name: 'description',
          content: fromConstants.MetaDescription.HDSLocator
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: fromConstants.MetaKeyWords.HDSLocator
        });
        break;
      case fromServices.LocatorTools.OrganTransplantCenter:
        this.titleService.setTitle(fromConstants.PageNames.OrganTransplantProgram);
        this.metaService.updateTag({
          name: 'description',
          content: fromConstants.MetaDescription.OPTOXFind
        });
        this.metaService.updateTag({
          name: 'keywords',
          content: fromConstants.MetaKeyWords.OPTOXFind
        });
        break;
    }
  }

  ngAfterViewInit() {
    this.initMetaData();
  }
}
